var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeFleet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 432 429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    display: "none"
  }, /*#__PURE__*/React.createElement("image", {
    width: 365,
    height: 360,
    transform: "translate(-39 -31) scale(1.4)",
    xlinkHref: "icon-de-fleet-1.png"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.5,359c0-.2,0-.5,0-.7v-91.8c0-3.2-1.2-6.3-3.4-8.7l-33.7-36.3c-1.2-1.3-2.2-2.9-2.8-4.6l-19.9-59.8c-.1-.4-.3-.7-.4-1.1-5.6-13-18.1-18.4-23.2-20.2-1.3-.4-2.7-.7-4.1-.7H106.6c-1.4,0-2.8.2-4.1.7-5.1,1.7-17.6,7.2-23.2,20.2-.2.4-.3.7-.4,1.1l-19.9,59.8c-.6,1.7-1.5,3.3-2.8,4.6l-33.7,36.3c-2.2,2.4-3.4,5.5-3.4,8.7v91.8c0,.2,0,.5,0,.7,0,0,0,.1,0,.2-.4,7.2,5.5,13.3,12.7,13.3h371.1c7.2,0,13.1-6,12.7-13.3,0,0,0-.2,0-.2Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.5,
    y1: 218.5,
    x2: 376,
    y2: 218.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 345.5,
    x2: 100.5,
    y2: 345.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333,
    y1: 345.5,
    x2: 385.5,
    y2: 345.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.5,
    y1: 345.5,
    x2: 284.5,
    y2: 345.5,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6,275.6l20.5,21.4c.4.4.7.8,1,1.3,1.3,2.1,4.2,8-.2,11.1s-2.4,1.1-3.7,1.1h-55.9s-5.2.7-8.1-3-1.5-3-1.5-4.6v-21.4s-1-7.6,6.5-7.8l36.5-.2c1.9,0,3.7.8,5,2.1Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,275.6l-20.5,21.4c-.4.4-.7.8-1,1.3-1.3,2.1-4.2,8,.2,11.1,1.1.8,2.4,1.1,3.7,1.1h55.9s5.2.7,8.1-3c1.1-1.3,1.5-3,1.5-4.6v-21.4s1-7.6-6.5-7.8l-36.5-.2c-1.9,0-3.7.8-5,2.1Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,310.2l-106.8.8c-2,0-3.8-.8-5.1-2.2l-23.9-24.7c-3.5-4-.5-10.1,5-10.1h151.9c5.5,0,8.5,5.9,5.1,10l-21.2,23.9c-1.2,1.5-3.1,2.3-5.1,2.3Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,372.2v23.8c0,11.6-8.5,21-19,21h-38.5c-10.5,0-19-9.4-19-21v-23.8",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,372.2v23.8c0,11.6-8.5,21-19,21h-38.5c-10.5,0-19-9.4-19-21v-23.8",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.5,
    y: 189.5,
    width: 47,
    height: 32,
    rx: 12,
    ry: 12,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 189.5,
    width: 47,
    height: 32,
    rx: 12,
    ry: 12,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,79.5v24c0,6.6-4.2,12-9.4,12h-59.3c-5.1,0-9.4-5.4-9.4-12V26c0-6.6,4.2-12,9.4-12h59.3c5.1,0,9.4,5.4,9.4,12",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,87.9",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,26v22.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.9 62 266.3 45.5 266.3 78.4 294.9 62"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271,
    y1: 63,
    x2: 227.5,
    y2: 63,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeFleet);
export default __webpack_public_path__ + "static/media/icon-de-fleet.5bf2afac592041f58f578e539bce34de.svg";
export { ForwardRef as ReactComponent };